import accounts_marketplace from 'i18n/adsimple/ru/accounts_marketplace.yml'
import advertisers from 'i18n/adsimple/ru/advertisers.yml'
import agency from 'i18n/adsimple/ru/agency.yml'
import audits from 'i18n/adsimple/ru/audits.yml'
import auth from 'i18n/adsimple/ru/auth.yml'
import autoreplenish from 'i18n/adsimple/ru/autoreplenish.yml'
import banners from 'i18n/adsimple/ru/banners.yml'
import billing from 'i18n/adsimple/ru/billing.yml'
import campaigns_editor from 'i18n/adsimple/ru/campaigns_editor.yml'
import common from 'i18n/adsimple/ru/common.yml'
import cookie_banner from 'i18n/adsimple/ru/cookie-banner.yml'
import countries from 'i18n/adsimple/ru/countries.yml'
import industries from 'i18n/adsimple/ru/industries.yml'
import media_planner from 'i18n/adsimple/ru/media_planner.yml'
import oauth from 'i18n/adsimple/ru/oauth.yml'
import partners_program from 'i18n/adsimple/ru/partners_program.yml'
import payment_order from 'i18n/adsimple/ru/payment_order.yml'
import promised_payment from 'i18n/adsimple/ru/promised_payment.yml'
import pulse from 'i18n/adsimple/ru/pulse.yml'
import recommendations from 'i18n/adsimple/ru/recommendations.yml'
import referral from 'i18n/adsimple/ru/referral.yml'
import reward_calculator from 'i18n/adsimple/ru/reward_calculator.yml'
import services from 'i18n/adsimple/ru/services.yml'
import statistics from 'i18n/adsimple/ru/statistics.yml'
import tickets from 'i18n/adsimple/ru/tickets.yml'
import user from 'i18n/adsimple/ru/user.yml'
import wallets from 'i18n/adsimple/ru/wallets.yml'
import benchmarks from 'i18n/getuniq/ru/benchmarks.yml'
import payment_profiles from 'i18n/getuniq/ru/payment_profiles.yml'

export default {
  accounts_marketplace,
  advertisers,
  agency,
  audits,
  benchmarks,
  auth,
  autoreplenish,
  banners,
  billing,
  campaigns_editor,
  common,
  cookie_banner,
  countries,
  industries,
  media_planner,
  oauth,
  partners_program,
  payment_profiles,
  payment_order,
  promised_payment,
  pulse,
  recommendations,
  referral,
  reward_calculator,
  services,
  statistics,
  tickets,
  user,
  wallets,
}
